<div class="image-editor-wrapper" [class.small]="small()">
  <input
    [id]="inputId"
    type="file"
    class="hidden-input"
    [accept]="accept()"
    (change)="fileChangeEvent($event)"
    #fileInput
  />
  <div class="ct-card image-editor-card">
    <div class="editor-layout">
      <div class="preview">
        <div
          class="dropzone checkerboard"
          role="region"
          [attr.aria-label]="
            imageForDisplay()
              ? ('ct-library.image-editor.preview-alt' | transloco)
              : ('ct-library.image-editor.no-image-selected' | transloco)
          "
          [class.invalid]="control().invalid && submitAttempt()"
        >
          @if (imageForDisplay(); as previewSrc) {
            <img
              [src]="previewSrc | safeUrl"
              [attr.alt]="'ct-library.image-editor.preview-alt' | transloco"
            />
          }
        </div>
      </div>
      <div
        class="image-editor-toolbar"
        role="toolbar"
        [attr.aria-label]="'ct-library.image-editor.toolbar-aria' | transloco"
      >
        <button
          type="button"
          class="action half icon-start"
          (click)="fileInput.click()"
          [attr.aria-label]="
            'ct-library.image-editor.upload-button' | transloco
          "
        >
          <fa-icon [icon]="faUpload" aria-hidden="true" />
          <span>{{ 'ct-library.image-editor.upload-button' | transloco }}</span>
        </button>
        @if (imageForDisplay()) {
          <button
            type="button"
            class="action half danger icon-start"
            (click)="deleteConfirm.modal.open()"
            [attr.aria-label]="
              'ct-library.image-editor.delete-button' | transloco
            "
          >
            <fa-icon [icon]="faTrash" aria-hidden="true" />
            <span>{{
              'ct-library.image-editor.delete-toolbar-button' | transloco
            }}</span>
          </button>
        }
      </div>
    </div>
  </div>
</div>

<ct-lib-confirm-modal
  [confirmLabel]="'ct-library.image-editor.upload-button' | transloco"
  [cancelLabel]="'ct-library.image-editor.discard-button' | transloco"
  #cropperModal
  (onConfirm)="confirmCrop()"
  (onClose)="fileInput.value = ''"
>
  <image-cropper
    [imageFile]="inputFile ?? undefined"
    [maintainAspectRatio]="maintainRatio()"
    [aspectRatio]="ratio()"
    format="png"
    (imageCropped)="imageCropped($event)"
    [output]="'base64'"
  >
  </image-cropper>
</ct-lib-confirm-modal>

<ct-lib-confirm-modal
  [confirmLabel]="'ct-library.image-editor.delete-button' | transloco"
  (onConfirm)="onDeleteFn()"
  #deleteConfirm
>
  <p class="text-start">
    {{ 'ct-library.image-editor.delete-modal.text' | transloco }}
  </p>
</ct-lib-confirm-modal>
